import { PaginatedFavoritedSamplesQuery } from 'apollo/sample/sample.gql';
import { PaginatedFavoritedPacksAndRepacksQuery } from 'apollo/packAndRepack/packAndRepack.gql';
import { EventIds } from '../../constants';

const favoritesQueryConfig = {
    samples: {
        query: PaginatedFavoritedSamplesQuery,
        pathToItems: 'paginatedFavoritedSamples',
        pathToTotalItems: 'totalSampleRecords',
        failureEvent: {
            eventId: EventIds.GetFavoriteSamplesFailed,
            message: 'Favorite samples page request failed',
        },
    },
    packs: {
        query: PaginatedFavoritedPacksAndRepacksQuery,
        pathToItems: 'paginatedFavoritedPacksAndRepacksV2',
        pathToTotalItems: 'totalRecords',
        failureEvent: {
            eventId: EventIds.GetFavoritePacksAndRepacksFailed,
            message: 'Favorite packs and repacks page request failed',
        },
    },
};

export default favoritesQueryConfig;
